module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap physical-stores-wrap flex-column"
  }, [_c('div', {
    staticClass: "head verticalM"
  }, [_c('div', {
    staticClass: "verticalM-box address"
  }, [_c('span', {
    staticClass: "ellipsis",
    on: {
      "click": function($event) {
        _vm.addressPopup = true;
        _vm.isAddress = true
      }
    },
    model: {
      value: (_vm.addressMsgShow),
      callback: function($$v) {
        _vm.addressMsgShow = $$v
      },
      expression: "addressMsgShow"
    }
  }, [_vm._v(_vm._s(_vm.addressMsgShow))])]), _vm._v(" "), _c('div', {
    staticClass: "verticalM-box brand"
  }, [_c('span', {
    staticClass: "ellipsis",
    on: {
      "click": function($event) {
        _vm.addressPopup = true;
        _vm.isAddress = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.brandName))])])]), _vm._v(" "), (_vm.amap) ? _c('div', {
    staticClass: "flex-item map"
  }, [_c('el-amap', {
    staticClass: "amap-demo",
    attrs: {
      "vid": "amapDemo",
      "center": _vm.amap.center,
      "map-manager": _vm.amap.amapManager,
      "zoom": _vm.amap.zoom,
      "events": _vm.amap.events
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('mu-popup', {
    attrs: {
      "position": "bottom",
      "popupClass": "popup-bottom physical-popup",
      "open": _vm.addressPopup
    },
    on: {
      "close": function($event) {
        _vm.addressPopup = false
      }
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.isAddress ? '所在地区' : '选择品牌')), _c('span', {
    on: {
      "click": function($event) {
        _vm.addressPopup = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "popup-content"
  }, [(_vm.isAddress) ? _c('div', {
    staticClass: "chooseList forbid-sel-text",
    class: {
      'chooseTwo': _vm.shoWOr == 2,
      'chooseOne': _vm.shoWOr == 1
    }
  }, [_c('div', {
    staticClass: "pShow"
  }, [(_vm.shoWOr <= 1) ? _c('samp', {
    staticClass: "sampOne",
    on: {
      "click": function($event) {
        return _vm.clickProvince(1)
      }
    }
  }, [_vm._v("请选择")]) : _vm._e(), _vm._v(" "), (_vm.shoWOr >= 2) ? _c('samp', {
    on: {
      "click": function($event) {
        return _vm.clickProvince(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.addressProvince))]) : _vm._e(), _vm._v(" "), (_vm.shoWOr >= 3) ? _c('samp', {
    on: {
      "click": function($event) {
        return _vm.clickProvince(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.cityNameShow))]) : _vm._e(), _vm._v(" "), (_vm.shoWOr == 2) ? _c('samp', {
    staticClass: "sampTwo"
  }, [_vm._v("请选择")]) : _vm._e()]), _vm._v(" "), (_vm.shoWOr == 1) ? _c('div', {
    staticClass: "chooseProvince"
  }, _vm._l((_vm.arealistMsg), function(provinceShow) {
    return _c('span', {
      on: {
        "click": function($event) {
          return _vm.shooseProvince(provinceShow.areaId, provinceShow.areaName)
        }
      }
    }, [_vm._v(_vm._s(provinceShow.areaName))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.shoWOr == 2) ? _c('div', {
    staticClass: "chooseProvince"
  }, _vm._l((_vm.cityListShow), function(cityShow) {
    return _c('span', {
      class: {
        'chooseCityStyle': _vm.chooseCityId == cityShow.areaId
      },
      on: {
        "click": function($event) {
          return _vm.shooseCity(cityShow.areaId, cityShow.areaName)
        }
      }
    }, [_vm._v(" " + _vm._s(cityShow.areaName))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.shoWOr == 3) ? _c('div', {
    staticClass: "chooseProvince"
  }, _vm._l((_vm.areaAddressMsg), function(areaListShow) {
    return _c('span', {
      class: {
        'chooseCityStyle': _vm.chooseAreaId == areaListShow.areaId
      },
      on: {
        "click": function($event) {
          return _vm.shooseArea(areaListShow.areaId, areaListShow.areaName)
        }
      }
    }, [_vm._v(" " + _vm._s(areaListShow.areaName))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.shoWOr == 4) ? _c('div', {
    staticClass: "chooseProvince"
  }, _vm._l((_vm.getStreetMsgList), function(streetListShow) {
    return _c('span', {
      class: {
        'chooseCityStyle': _vm.chooseStreetId == streetListShow.areaId
      },
      on: {
        "click": function($event) {
          return _vm.shooseStreet(streetListShow.areaId, streetListShow.areaName)
        }
      }
    }, [_vm._v(" " + _vm._s(streetListShow.areaName))])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isAddress) ? _c('div', _vm._l((_vm.Brands), function(brand, index) {
    return _c('mu-checkbox', {
      key: brand.linkTarget,
      staticClass: "demo-checkbox",
      attrs: {
        "name": "group",
        "labelLeft": true,
        "nativeValue": brand.linkTarget,
        "label": brand.linkName
      },
      on: {
        "change": function($event) {
          return _vm.selBrand($event, index)
        }
      },
      model: {
        value: (brand.selected),
        callback: function($$v) {
          _vm.$set(brand, "selected", $$v)
        },
        expression: "brand.selected"
      }
    })
  }), 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bottom-btn-box"
  }, [_c('div', {
    staticClass: "bottom-full-button"
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "确认",
      "fullWidth": "",
      "primary": ""
    },
    on: {
      "click": _vm.adressFirm
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63d0a846","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/physicalStores/physicalStores.vue
// module id = 407
// module chunks = 68